import type { ModuleDefinition } from "../types";

/**
 * Documents (ADR 0007) have no screens of their own: the Documents card sits on the member, household and vendor pages. This definition
 * exists so those pages can ask whether the club's license includes the module (`useModuleBlocked()(documentsLicense)`).
 */
export const documentsLicense: ModuleDefinition = {
  id: "documents",
  labelKey: "module.documents",
  nav: [],
  routes: [],
};

export const documentsModule: ModuleDefinition = {
  ...documentsLicense,
  labelKey: "files.title",
  nav: [{ id: "files", labelKey: "files.title", to: "/files", icon: "note", permission: "documents.read" }],
  routes: [{ path: "files", permission: "documents.read", load: () => import("./FilesPage") }],
};
